import returnDashboardIcon from '../../../assets/images/return-dashboard-icon.svg'
import Text from '../../atoms/Text/Text'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import KeyboardControl from '../../../components/molecules/KeyboardControls/KeyboardControl'
import ControlHighlight from '../../../components/molecules/KeyboardControls/ControlHighlight'
import { HighlightEffect } from '../../../enums/KeyboardControls'

interface ReturnButtonProps {
  id: string
  onClick: () => void
  text: string
}

/** Return to dashboard button. */
const ReturnButton: React.FC<ReturnButtonProps> = ({ id, onClick, text }) => {
  const keyboardControls = useKeyboardControls()

  const idButton = `button-${id}`

  return (
    <ControlHighlight
      active={keyboardControls.isEnabled && keyboardControls.isElementFocused(idButton)}
      highlightEffect={HighlightEffect.ButtonHexOutline}
      data-testid={`highlight-${idButton}`}
    >
      <KeyboardControl>
        <button
          id={idButton}
          data-testid={idButton}
          className='px-[17px] flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold py-[14px] hover:bg-[rgba(52,232,158,0.2)]'
          onClick={onClick}
          aria-label={text}
        >
          <img src={returnDashboardIcon} className='w-[27px]' alt='' aria-hidden='true' />
          <Text className='ml-4' text={text} size='SM' type='span' />
        </button>
      </KeyboardControl>
    </ControlHighlight>
  )
}

export default ReturnButton
